var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseWrapper',{attrs:{"title":_vm.title,"subtitle":_vm.subtitle}},[_c('BaseButton',{attrs:{"color":"#FF1D30","outlined":"","text":_vm.buttonText,"className":"text-none"},on:{"click":function($event){return _vm.$emit('onRemove')}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }